const SERVICE_NAME = 'NEWS_SERVICE';

export const NEWS_FETCH_REQUEST = SERVICE_NAME + '_FETCH_REQUEST';
export const NEWS_FETCH_SUCCESS = SERVICE_NAME + '_FETCH_SUCCESS';
export const NEWS_FETCH_FAILURE = SERVICE_NAME + '_FETCH_FAILURE';
